import i18n from '@/plugins/i18n'

/**
 * =========================================
 * Snackbar Store
 * =========================================
 *
 * Handles the snackbar of the application.
 *
 * =========================================
 */
export default {
  namespaced: true,
  strict: process.env.APP_ENV === 'development',
  state () {
    return {
      timeout: null,
      top: '',
      bottom: '',
      right: '',
      left: '',
      multiLine: false,
      vertical: false,
      snackbar: false,
      color: '',
      message: '',
      closeLabel: '',
      icon: null,
      iconColor: null
    }
  },
  mutations: {
    /**
     * Sets the default values for snackbar.
     *
     * @param state
     */
    setDefault (state) {
      state.timeout = 3000
      state.top = document.documentElement.clientWidth <= 960 || false
      state.bottom = document.documentElement.clientWidth >= 960 || false
      state.right = false
      state.left = false
      state.multiLine = false
      state.vertical = false
      state.snackbar = false
      state.color = ''
      state.closeLabel = i18n.t('common.close')
      state.message = ''
      state.icon = null
      state.iconColor = null
    },

    /**
     * Overrides snackbar properties.
     *
     * @param state
     * @param config
     */
    setSnackbar (state, config) {
      for (const key in config) {
        state[key] = config[key]
      }

      state.snackbar = true
    }
  },
  actions: {
    /**
     * Shows the snackbar and overrides some properties.
     *
     * @param context
     * @param config
     */
    showSnackbar (context, config) {
      context.commit('setDefault')
      context.commit('setSnackbar', config)
    },

    /**
     * Hides the snackbar in view.
     *
     * @param context
     */
    closeSnackbar (context) {
      context.commit('setDefault')
    }
  }
}
